import { ReferrerApp } from "../types/referrerApp";

const REFERRER_SESSION_KEY = "referrerApp";

export const getReferrerFromSession = (): string | null =>
  sessionStorage.getItem(REFERRER_SESSION_KEY);

export const saveReferrerToSession = (referrerApp: ReferrerApp) => {
  sessionStorage.setItem(REFERRER_SESSION_KEY, JSON.stringify(referrerApp));
};
